export default __webpack_public_path__ + "d64dbe560aa131ce76a2be0c73e4e4083b1851f874ca3b164401acd60540159b.svg";